import React from "react";
import { Link } from "react-router-dom";
import "./blogCard.css";

const BlogCard = ({ blog }) => {
    return (
        <div className="blog-card">
            <div className="blog-content">
                <h3>{blog.title}</h3>
                <p>{blog.excerpt}</p>

                <Link to={`/Blog/${blog.slug}`} className="read-more">
                    Read More →
                </Link>
            </div>
        </div>
    );
};

export default BlogCard;